// test2679
(2679 && 0);
